import React from "react";

export const SectionLabel = ({ children, number, testId }) => (
  <div className="flex items-center gap-4 mb-8" data-testid={testId}>
    {number && (
      <span className="text-[10px] font-display font-light tracking-[0.4em] text-gray-600">
        {number}
      </span>
    )}
    <span className="h-px w-12 bg-gray-700" />
    <span className="text-[10px] font-display font-light uppercase tracking-[0.4em] text-gray-400">
      {children}
    </span>
  </div>
);

export const SectionTitle = ({ children, className = "", testId }) => (
  <h2
    data-testid={testId}
    className={`font-display font-extralight uppercase tracking-[0.2em] text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.15] ${className}`}
  >
    {children}
  </h2>
);

export const Hairline = ({ className = "" }) => (
  <div className={`hairline ${className}`} aria-hidden="true" />
);

export const PageHeader = ({ eyebrow, title, description, testId }) => (
  <section
    data-testid={testId}
    className="px-6 md:px-12 lg:px-20 pt-24 md:pt-32 pb-16 md:pb-20 border-b border-gray-900"
  >
    <div className="max-w-6xl">
      {eyebrow && (
        <p className="text-[10px] font-display font-light uppercase tracking-[0.5em] text-gray-500 mb-8">
          {eyebrow}
        </p>
      )}
      <h1 className="font-display font-extralight uppercase tracking-[0.18em] text-white text-4xl sm:text-5xl lg:text-7xl leading-[1.05]">
        {title}
      </h1>
      {description && (
        <p className="mt-10 text-sm sm:text-base font-light tracking-wide text-gray-400 leading-relaxed max-w-2xl">
          {description}
        </p>
      )}
    </div>
  </section>
);
